import { render, staticRenderFns } from "./EnhanceMenu.vue?vue&type=template&id=3a1ff671&"
import script from "./EnhanceMenu.vue?vue&type=script&lang=ts&"
export * from "./EnhanceMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports